export default "__VITE_ASSET__ead05e17__"